import { connect } from "react-redux";

import actions from "../../actions";
import Construction_management from "../../components/master/Construction_management";

const mapStateToProps = (state) => {
  return {
    masterItems: state.construction_management.masterItems,
    text: state.construction_management.text,
    items: state.construction_management.items,
    current: state.construction_management.current,
    fetching: state.construction_management.fetching,
    isError: state.construction_management.isError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeSearchText: (text) => dispatch(actions.construction_management.changeSearchText(text)),
    fetchItems: (callback) => dispatch(actions.construction_management.fetchItems(callback)),
    searchItems: (text, callback) => dispatch(actions.construction_management.searchItems(text, callback)),
    fetchItem: (id, callback, failedCallback) =>
      dispatch(actions.construction_management.fetchItem(id, callback, failedCallback)),
    createItem: (data, handleSuccess, handleCancel) =>
      dispatch(actions.construction_management.createItem(data, handleSuccess, handleCancel)),
    updateItem: (data, handleSuccess, handleCancel, failedCallback) =>
      dispatch(actions.construction_management.updateItem(data, handleSuccess, handleCancel, failedCallback)),
    deleteItem: (id, name) => dispatch(actions.construction_management.deleteItem(id, name)),
    setUnloadAlert: () => dispatch(actions.app.setUnloadAlert()),
    clearUnloadAlert: () => dispatch(actions.app.clearUnloadAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Construction_management);
